import util from '../util'

let controller = 'ExpBACENInstituicao'

export default Object.assign({}, util.GetCrud(controller, ['get', 'post', 'put']))
